export const COLLABORATORS_ACTION_PREFIX = '[Collaborators State]';

export class FetchCollaboratorPhotos {
  static readonly type = `${COLLABORATORS_ACTION_PREFIX} Fetch Collaborator Photos`;
  constructor(public photoIds: string[]) {}
}

export class FetchCollaboratorData {
  static readonly type = `${COLLABORATORS_ACTION_PREFIX} Fetch Collaborator Data`;
  constructor(public collaboratorUserIds: string[]) {}
}
